import { DownloadOutlined } from '@ant-design/icons'

import { BranchServiceSaleAction } from '@pages/Branch/ServiceSalePage'

import PageTitle, { PageTitleAction } from '@components/molecules/PageTitle'

type Props = {
  onAction: (type: BranchServiceSaleAction) => void
}

export default function BranchServiceSaleTitle({ onAction }: Props): JSX.Element {
  const actions: PageTitleAction[] = [
    { label: '다운로드', buttonType: 'dashed', icon: <DownloadOutlined />, onClick: () => onAction('export') },
  ]

  return <PageTitle title="서비스 판매내역" actions={actions} />
}
